export default __webpack_public_path__ + "static/media/Group924.be389e32.svg";